import { render, staticRenderFns } from "./ProjectStaffInformation.vue?vue&type=template&id=28efacc5&scoped=true&"
import script from "./ProjectStaffInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectStaffInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStaffInformation.vue?vue&type=style&index=0&id=28efacc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28efacc5",
  null
  
)

export default component.exports